var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialBoosterStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 181,
    viewBox: "0 0 135 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7396_369328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5 10L93.7195 74.3146L121.306 16.1277L99.6683 76.7787L147.422 33.5779L104.221 81.3317L164.872 59.694L106.685 87.2805L171 90.5L106.685 93.7195L164.872 121.306L104.221 99.6683L147.422 147.422L99.6683 104.221L121.306 164.872L93.7195 106.685L90.5 171L87.2805 106.685L59.694 164.872L81.3317 104.221L33.5779 147.422L76.7787 99.6683L16.1277 121.306L74.3146 93.7195L10 90.5L74.3146 87.2805L16.1277 59.694L76.7787 81.3317L33.5779 33.5779L81.3317 76.7787L59.694 16.1277L87.2805 74.3146L90.5 10Z",
    fill: "#0BC4F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7396_369328",
    x: 0.2,
    y: 0.2,
    width: 180.6,
    height: 180.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.9,
    result: "effect1_foregroundBlur_7396_369328"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialBoosterStar);
export default __webpack_public_path__ + "static/media/tutorial-booster-star.57e38cd4a21ec4a5b62983e4c799e304.svg";
export { ForwardRef as ReactComponent };